module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_vm._v("Capítulo 1")]), _vm._v(" "), _c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])]), _c('p', {
    staticClass: "first-in-chapter",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-chapter-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("P")]), _vm._v("or mais que a Srta")]), _vm._v(". Jane Featherstone amasse sua adorável prima, Lady Sarah Bertram, ela decididamente não estava gostando de passear no Hyde Park com ela naquele belo dia de maio. Não que ela tivesse algum problema com Lady Sarah, mas por causa do ciúme imperdoável da Srta. Featherstone. Sua inveja secreta era positivamente ilógica (e a Srta. Jane Featherstone sempre se orgulhara de sua capacidade de dominar os princípios da lógica). ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Não era porque algum dos Mais Elegíveis Pretendentes Solteiros fosse dar uma segunda olhada na extremamente monótona Srta. Featherstone quando a deslumbrante Lady Sarah estava pendurada ao lado dela. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Nos dez minutos desde que a carruagem aberta das donzelas passou pelos portões do movimentado parque, nada menos que cinco jovens nobres, de boa aparência e amáveis pararam seus cavalos para fazer papel de bobos para Lady Sara.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("E não era de se admirar. Assim que sua prima fosse apresentada à "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("alta sociedade")]), _vm._v(" no baile desta noite, cada Cavalheiro Elegível ao Matrimonio em todo o reino estaria se lançando sobre a linda garota. Com cabelos da cor do trigo brilhando ao sol, um rosto impecável e suave como a pérola mais fina e uma figura curvilínea como a de uma deusa romana, Lady Sarah subiria sem esforço ao topo do grupo de debutantes desta temporada. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Quando fosse descoberto que a bela Lady Sara possuía uma das maiores fortunas da Grã-Bretanha, não haveria como parar a debandada de pretendentes para Clegg House em Berkley Square.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Devido ao fato de que a bela herdeira ainda não havia sido apresentada, os jovens paqueradores não poderiam iniciar uma conversa diretamente com ela até que a Srta. Featherstone fizesse a gentileza de facilitar as apresentações. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Portanto, a Srta. Featherstone foi—pela primeira vez desde sua própria apresentação, três anos antes—objeto dos profundos cumprimentos e bajulações dos jovens pretendentes. Depois que as saudações eram trocadas, a Srta. Featherstone não tinha escolha a não ser apresentar esses Elegíveis Solteiros a sua espetacular companheira. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("E então a Srta. Featherstone desaparecia silenciosamente como fumaça no ar. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Deixando o jovem Lord Averworth observando com adoração Lady Sarah continuar pela larga alameda do parque, a bela jovem voltou-se para sua prima, seus olhos azuis brilhando de excitação. \"Todos os rapazes que conheci são extremamente gentis e bonitos. Mal posso esperar até esta noite.\" ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Atrevo-me a dizer que você será como uma rainha em sua corte.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Você vai me fazer corar.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Asseguro-lhe que não é minha intenção. Não queremos que nenhuma vermelhidão estrague sua adorável tez.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lady Sarah era honesta demais para fingir modéstia. Não se passava um dia em sua vida sem que sua notável beleza fosse comentada. \"Nem eu quero. É por isso que estou usando este chapéu horrivelmente grande hoje.\" ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A Srta. Featherstone balançou a cabeça. \"Seu chapéu não é horrível. Tudo o que você usa evidencia seu gosto impecável.\" Na verdade, pensou a Srta. Featherstone, ela nunca tinha visto um chapéu mais bonito. Enquanto a maioria das senhoras que ela conhecia mudasse o acabamento dos chapéus para combinar com suas roupas, o chapéu de Lady Sarah combinava perfeitamente com o amarelo pálido de seu vestido matinal. Ela tinha o luxo de ter um chapéu de cor diferente para cada vestido?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Você realmente, realmente gosta do vestido que usarei esta noite?\" Lady Sarah perguntou.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Eu realmente gosto, embora eu ouse dizer que se você usasse um cobertor de cavalo ainda assim você seria a garota mais bonita do baile.\" ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Você é muito gentil, minha doce Jane.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A Srta. Featherstone suspirou. “Gostaria de ser mais gentil com Lavinia.” Ela sempre rezava, em vão, para que ela e a sarcástica esposa de seu irmão se entendessem melhor.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Os olhos de Lady Sarah se estreitaram. \"Essa mulher horrível é positivamente odiosa! Eu nunca vou entender como seu irmão pode ter escolhido se casar com ela.\" ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Seu generoso dote ajudou.\" Infelizmente, nenhum dos Featherstones tinha os... bolsos "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("fundos")]), _vm._v(" cheios de dinheiro.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Então ele provavelmente não a ama de jeito nenhum. Esse é o problema quando se tem fortuna. Nunca se sabe se um cavalheiro está apaixonado por você ou por seu dinheiro.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Se ele não a amava quando se casaram, acredito que ele a ama agora, mas você não precisa ter medo de caçadores de fortunas\", assegurou a Srta. Featherstone. “Os homens se apaixonariam terrivelmente por você, mesmo se você fosse tão pobre quanto... bem, tão pobre quanto eu.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Sua falta de fortuna explica por que você não recebeu nenhum pedido de casamento, pois possui muitos atributos.\" ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A Srta. Featherstone ajustou a aba de seu chapéu para proteger os olhos do sol forte. \"Por favor, minha querida prima, esclareça-me sobre esses atributos.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Você pode não ser bonita como eu, mas você é realmente bonita. De um jeito discreto.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Você obviamente tem estado muito perto do meu pai.\" ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Isso não tem nada a ver com a minha opinião, eu lhe garanto. Possuo uma boa visão. Seu rosto é bonito. Você é terrivelmente inteligente. E não há nada de ofensivo em sua figura.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Se alguém é dado a admirar mastros de bandeira.\" A Srta. Featherstone acenou com a cabeça para um par de garotas sorridentes que passavam, com guarda-sóis protegendo seus rostos do sol. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Muitos homens preferem mulheres esbeltas. Lembre-se, são mulheres como eu—mulheres com dotes generosos—que ficam corpulentas com a idade.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Isso era verdade. Mas, na verdade, muitos homens preferiam mulheres corpulentas. Basta olhar para o próprio Regente! A maioria das mulheres com quem ele esteve romanticamente ligado tendia a ser tão roliça quanto ele. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Enquanto seguiam na procissão de belas carruagens em direção a um bosque, a Srta. Featherstone regozijava-se com o calor do sol, seus pensamentos serpenteando em torno de sua própria inveja abominável. Não havia razão para se sentir em competição com Lady Sarah. Ela amava sua prima e sabia que nunca poderia competir com ela nos níveis mais altos da sociedade. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A Srta. Featherstone sempre entendera que seu próprio futuro seria com um homem solteirão, sem nenhuma distinção particular. O problema era que nem mesmo um solteirão sem nenhuma distinção particular jamais havia honrado Jane Featherstone com uma proposta de casamento.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("O que era uma pena. Seu pai estava com quase setenta anos, e quando ele se fosse, Jane se tornaria um fardo na casa de seu irmão e Lavinia—uma perspectiva tão indesejável para Lavinia quanto para Jane.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Quando a carruagem delas se aproximou do Serpentine "), _c('span', {
    staticStyle: {
      "font-size": "x-small"
    }
  }, [_vm._v("(1)")]), _vm._v(", ela pensou ter reconhecido Lord Slade cavalgando sozinho em um impressionante cavalo negro. Suas costas se endireitaram. Seu olhar se estreitou. E quando ela percebeu que ele estava cavalgando em direção a elas, seu batimento cardíaco ressoou contra o seu peito. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Desde o dia em que a Srta. Jane Featherstone saiu da sala de aula, ela secretamente idolatrava este homem. Muito antes de ele assumir o título, ela admirava seus brilhantes discursos na House of Commons "), _c('span', {
    staticStyle: {
      "font-size": "x-small"
    }
  }, [_vm._v("(2)")]), _vm._v(". Seu querido pai era um dos mais leais aliados de Lord Slade contra os bestiais Tories "), _c('span', {
    staticStyle: {
      "font-size": "x-small"
    }
  }, [_vm._v("(3)")]), _vm._v(". Ela havia enchido um livro com relatos de jornais sobre Sua Senhoria e o enfiado em uma gaveta debaixo de sua caixa de joias.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ela não apenas admirava muito sua inteligência e filosofia política, mas também achava que ele era talvez o homem fisicamente mais atraente que ela já vira. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Claro, ele provavelmente não se lembraria de alguém tão comum quanto ela. Antes de se mudar para a House of Lords após a morte de seu pai, ele costumava ir a casa deles para discutir a reforma política com o pai dela e seus colegas da House of Commons. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Como ela servia como anfitriã de seu pai e porque seu pai era bastante indulgente com sua única filha, a Srta. Featherstone tinha permissão para participar dessas conversas.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("À medida que Lord Slade se aproximava, seus olhos correram com apreciação para Lady Sarah, depois para Jane, e um sorriso de reconhecimento iluminou seu rosto bronzeado. Querido Deus! O homem ia parar e falar com elas. Ela estava tremendo tanto que duvidava que fosse capaz de falar alguma coisa. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("O cocheiro de libré escarlate parou quando viu que Lord Slade havia parado.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Boa tarde, Srta. Featherstone. Vejo que também está desfrutando deste lindo dia ensolarado.\" De seus ombros largos ao plano quadrado de seu rosto e seu cabelo castanho escuro penteado casualmente, o homem exalava a masculinidade mais robusta e bonita que ela já vira.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ele evitou as armadilhas dos homens elegantes e vestia roupas de montar sem cartola ou botas brilhantes. Suas calças cáqui se modelavam sobre pernas longas e musculosas, e suas botas marrons seriam mais apropriadas no campo do que aqui no meio de Londres. O fato de não ser escravo da moda o tornava ainda mais querido pela Srta. Featherstone. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Realmente, meu senhor,\" ela conseguiu dizer, grata por sua voz não ter traído a trepidação dentro dela.   ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ele assentiu com a cabeça, então seus brilhantes olhos negros examinaram Lady Sarah.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Jane percebeu que ele esperava ser apresentado a Insuperável. \"Lord Slade, posso lhe apresentar minha prima, Lady Sarah Bertram?\" ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lady Sarah concedeu seu sorriso brilhante a seu mais recente admirador, e eles trocaram saudações.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Depois de dizer tudo o que era apropriado, Lord Slade mais uma vez dirigiu sua atenção para a Srta. Featherstone. “Então vocês duas são parentes por parte de mãe? Lady Mary não era irmã do Conde de Clegg?” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Se a falecida mãe da Srta. Featherstone, Lady Mary a quem Sua Senhoria acabara de se referir, tivesse aparecido nessa trilha sinuosa, Jane não poderia ter ficado mais atordoada. Lord Slade se lembrou de que sua mãe era filha de um conde. “Sim. O Conde de Clegg, que é irmão de minha mãe, é o pai de Lady Sarah.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Então você é neta de George Berkley?\" ele disse a Lady Sarah.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Todos na "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("alta sociedade")]), _vm._v(" sabiam que a significativa fortuna bancária de George Berkley havia sido direcionada para sua primeira neta, que por acaso era a criatura insuperável que estava sentada ao seu lado na carruagem de seu pai no Hyde Park.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lady Sarah sorriu. \"Na verdade ele era meu avô. Você o conheceu?\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Uma pena que os longos cílios de sua prima caíssem sobre suas bochechas, pensou Jane. Alguém poderia ser mais bonita? Pontadas de ciúme espiralaram dentro dela. Que pena que Jane nunca poderia parecer tão insuperável para Sua Senhoria. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Não tive esse prazer, mas ele era o banqueiro de meu pai—que o admirava muito.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Assim como eu\", disse Lady Sarah, colocando em sua voz o tom mais doce possível.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Diga-me, minha senhora, por que ainda não a havia conhecido?\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Eu ainda não fui apresentada a sociedade. Bem, na verdade, fui apresentada à Rainha ontem.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"E ela vai ser apresentada à sociedade esta noite\", acrescentou Jane. \"Você vai assistir ao baile na Spencer House"), _c('span', {
    staticStyle: {
      "font-size": "x-small"
    }
  }, [_vm._v(" (4)")]), _vm._v(", meu senhor?\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Seu sorriso voltou ao seu rosto. \"Você pode ter certeza que eu vou.\" Ele tirou um chapéu invisível, presenteou-as com um sorriso contagiante e se despediu. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Quando ele estava fora do alcance de sua voz, Jane virou-se para sua prima. \"O que você achou de Lord Slade?\" ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lady Sarah deu de ombros. “Não achei nada. Admito, que eu estava preparada para não gostar dele. Papai, você sabe, detesta os modos radicais do homem no Parlamento. Ele está sempre resmungando sobre Lord Slade.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Então eu ouso dizer que meu tio também resmunga sobre o meu pai, pois ele e Lord Slade são farinha do mesmo saco.\" ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Não é nenhum segredo, é claro, que papai e seu pai não concordam em questões governamentais, mas seu pai é da família, então papai nunca o calunia.\" ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Os cavalheiros são muito mais agradáveis do que as damas.\" Como Lady Sarah poderia não estar maravilhada com seu "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Sublime Lord")]), _vm._v("? Será que a poeira levantada pelos cascos dos cavalos havia nublado sua visão? ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Você está certa. Papai nunca fala mal de Lavinia, e você deve admitir que "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("todo mundo")]), _vm._v(" fala mal de Lavinia.\" ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Jane assentiu distraidamente. Incompreensivelmente, Lady Sarah não havia demonstrado grande admiração por Lord Slade. \"Você não achou Lord Slade extraordinariamente bonito?\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lady Sarah encolheu os ombros novamente. \"Ele é... mais velho do que eu normalmente acho atraente.\" ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Ele não tem nem trinta anos!\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"E eu ainda não tenho dezoito anos!\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Então você se sente atraída por jovens perto dos dezoito anos?\" "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Muito estranho")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lady Sarah assentiu. \"Até a idade do meu irmão.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lord Harry tinha vinte e dois anos. “Mas a maioria dos homens dessa idade, a menos que tenham tido a sorte de ser bem-sucedidos, não está em condições financeiras de ter uma esposa...” A Srta. Featherstone franziu a testa. \"Tal consideração, porém, é desnecessária para uma dama de grande fortuna.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Realmente. Posso me casar com quem eu escolher.\" Ela deu um sorriso estupendo e declarou: \"Estarei casada em setembro.\" ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Se é isso que você quer, tenho certeza que você vai estar. Por que a pressa?\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Adoro a ideia de ter minha própria casa. Não seria maravilhoso casar com um homem com um castelo de família? Com minha fortuna eu poderia decorá-lo do jeito que eu quisesse. E eu amo crianças. Eu me vejo rodeada de lindas filhas loiras.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"E os filhos? E o marido?\" ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lady Sarah Bertram franziu o nariz perfeito. “Suponho que meu marido vai querer que lhe dê um herdeiro, embora não goste muito de meninos. Claro que desejo um marido.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Talvez você o encontre esta noite.\"     ")]), _vm._v(" "), _c('p', {
    staticClass: "section-break-symbol",
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("***")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene with-quote character-e"
  }, [_vm._v("\"E")]), _vm._v("u imploro que Vossa")]), _vm._v(" Senhoria fique parado\", disse Lipton a Lord Slade.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Com um suspiro profundo, Slade endireitou o pescoço e olhou em seu espelho de corpo inteiro. Seu criado se esforçava para amarrar a gravata que Lipton ficara bastante tempo passando. Era muito mais importante para Lipton do que para Slade que seu patrão apresentasse uma aparência admirável. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Se Slade tivesse liberdade para agradar apenas a si mesmo, ele não estaria parado ali em frente ao espelho. Ele não iria ao baile dos Spencers "), _c('span', {
    staticStyle: {
      "font-size": "x-small"
    }
  }, [_vm._v("(5)")]), _vm._v(" de jeito nenhum. E não estaria se preparando para se oferecer como o peixe do dia no mercado de peixes de Billingsgate. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Mas o conde não tinha liberdade para agradar a si mesmo. Ele agora era o chefe da família. Ele devia pensar nos outros. Comprar um novo quadro quase esgotou seus fundos limitados, e ele teria que adiar a apresentação das meninas por pelo menos mais um ano. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Como a política cambial havia dizimado o dinheiro de seu pai, simplesmente não havia dinheiro suficiente, apesar de todas as suas medidas para economizar. Ele havia alugado a casa em Londres e atualmente alugava um quarto em um endereço respeitável. Ele vendeu a cara carruagem e três de seus quatro cavalos. Ele e seus irmãos ocupavam apenas uma ala do castelo Dunvale em ruínas, que agora podia ser administrado por menos da metade de criados de quando o velho conde ainda era vivo. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Seu olhar seguiu as manipulações especializadas de Lipton, e ele franziu a testa profundamente. Por que ele fez aquela Promessa miserável, A Promessa que alteraria irrevogavelmente o curso de sua vida? ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Quão mais feliz ele era antes desta Promessa. Até que ele viu a Srta. Featherstone naquela tarde, ele quase havia esquecido o quanto gostava daquelas animadas discussões Whig "), _c('span', {
    staticStyle: {
      "font-size": "x-small"
    }
  }, [_vm._v("(6)")]), _vm._v(" nos jantares presididos pelo extraordinário pai da jovem. Ora, havia mais intelecto dentro daquelas paredes modestas do que em toda a House of Lords.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A porta de seu quarto se abriu e seu irmão entrou. Slade achava que seu irmão, o Capitão David St. John era uma bela figura em seu uniforme de House Guards "), _c('span', {
    staticStyle: {
      "font-size": "x-small"
    }
  }, [_vm._v("(7)")]), _vm._v(". As mulheres com certeza desmaiariam por ele esta noite. Elas sempre desmaiavam. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Achei que Lipton estava maluco quando me disse que você iria ao baile na casa de Lord Spencer esta noite. David olhou para Slade como se o irmão mais velho fosse deficiente mental. \"Não sabia que você gostava de debutantes.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Até agora, eu não gostava.\" Os lábios de Slade formaram uma linha sombria.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("David deu um tapa na testa. \"Oh, sim. A Promessa.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lord Slade assentiu quase imperceptivelmente, viu que Lipton não havia deixado sequer um fiapo em sua jaqueta de lãrecém-passada e ficou satisfeito com sua aparência. Nada muito colorido para ele. Preto e branco era perfeito. \"Devemos ir?\" ele perguntou a David.")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "font-size": "x-small",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-1"
  }, [_vm._v("(1")]), _vm._v(") Serpentine (também")]), _vm._v(" conhecido como Serpentine River) é um lago recreativo em Hyde Park, Londres, Inglaterra, criado em 1730 a pedido da Rainha Caroline. Embora seja comum referir-se a todo o corpo de água como Serpentine, o nome refere-se apenas à metade oriental do lago. Serpentine Bridge, que marca o limite entre Hyde Park e Kensington Gardens, também marca o limite oeste do lago Serpentine; a longa e estreita metade ocidental do lago é conhecida como Long Water. A Serpentina leva o nome de sua forma curva, semelhante a uma cobra, embora tenha apenas uma curva.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-small",
      "text-align": "justify"
    }
  }, [_vm._v("(2) House of Commons do Reino Unido é a Câmara do Povo do Parlamento do Reino Unido, composta por cerca de 650 membros chamados de Members of Parliament (MPs), para representar seus interesses e preocupações na Câmara dos Comuns, ou seja, o equivalente a deputado, sendo que um deles deve presidir a casa, sendo denominado Speaker. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-small",
      "text-align": "justify"
    }
  }, [_vm._v("(3) "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Tory")]), _vm._v(" é um antigo "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://pt.wikipedia.org/wiki/Partido_pol%C3%ADtico",
      "target": "_blank",
      "title": "Partido político"
    }
  }, [_vm._v("partido")]), _vm._v(" de tendência "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://pt.wikipedia.org/wiki/Conservadorismo",
      "target": "_blank",
      "title": "Conservadorismo"
    }
  }, [_vm._v("conservadora")]), _vm._v(" do "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://pt.wikipedia.org/wiki/Reino_Unido",
      "target": "_blank",
      "title": "Reino Unido"
    }
  }, [_vm._v("Reino Unido")]), _vm._v(", que reunia a "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://pt.wikipedia.org/wiki/Aristocracia",
      "target": "_blank",
      "title": "Aristocracia"
    }
  }, [_vm._v("aristocracia")]), _vm._v(" britânica. No princípio, tinha conotações depreciativas, já que procede da palavra "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://pt.wikipedia.org/wiki/L%C3%ADngua_irlandesa",
      "target": "_blank",
      "title": "Língua irlandesa"
    }
  }, [_vm._v("irlandesa")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("thairide")]), _vm._v(" ou "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("tóraighe")]), _vm._v(", que significava "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://pt.wikipedia.org/wiki/Bandoleiro",
      "target": "_blank",
      "title": "Bandoleiro"
    }
  }, [_vm._v("bandoleiro")]), _vm._v(", homem armado que se dedicava ao "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://pt.wikipedia.org/wiki/Roubo",
      "target": "_blank",
      "title": "Roubo"
    }
  }, [_vm._v("roubo")]), _vm._v(" e à "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://pt.wikipedia.org/wiki/Pilhagem",
      "target": "_blank",
      "title": "Pilhagem"
    }
  }, [_vm._v("pilhagem")]), _vm._v(", mas que pode ser "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://pt.wikipedia.org/wiki/Tradu%C3%A7%C3%A3o",
      "target": "_blank",
      "title": "Tradução"
    }
  }, [_vm._v("traduzido")]), _vm._v(" apenas por \"que pertence a um bando\".")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-small",
      "text-align": "justify"
    }
  }, [_vm._v("(4) Spencer House é o único "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://pt.wikipedia.org/wiki/Palacete",
      "target": "_blank",
      "title": "Palacete"
    }
  }, [_vm._v("palacete")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://pt.wikipedia.org/wiki/Londres",
      "target": "_blank",
      "title": "Londres"
    }
  }, [_vm._v("londrino")]), _vm._v(" privado do "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://pt.wikipedia.org/wiki/S%C3%A9culo_XVIII",
      "target": "_blank",
      "title": "Século XVIII"
    }
  }, [_vm._v("século XVIII")]), _vm._v(" que permaneceu intacto após as ações do tempo e os bombardeios sofridos pela cidade durante a "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://pt.wikipedia.org/wiki/Primeira_Guerra_Mundial",
      "target": "_blank",
      "title": "Primeira Guerra Mundial"
    }
  }, [_vm._v("Primeira")]), _vm._v(" e a "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://pt.wikipedia.org/wiki/Segunda_Guerra_Mundial",
      "target": "_blank",
      "title": "Segunda Guerra Mundial"
    }
  }, [_vm._v("Segunda Guerra Mundial")]), _vm._v(". Situa-se perto do "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://pt.wikipedia.org/wiki/Pal%C3%A1cio_de_St._James",
      "target": "_blank",
      "title": "Palácio de St. James"
    }
  }, [_vm._v("Palácio de St. James")]), _vm._v(", do "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://pt.wikipedia.org/wiki/Pal%C3%A1cio_de_Buckingham",
      "target": "_blank",
      "title": "Palácio de Buckingham"
    }
  }, [_vm._v("Palácio de Buckingham")]), _vm._v(" e do "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://pt.wikipedia.org/wiki/Pal%C3%A1cio_de_Westminster",
      "target": "_blank",
      "title": "Palácio de Westminster"
    }
  }, [_vm._v("Palácio de Westminster")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-small",
      "text-align": "justify"
    }
  }, [_vm._v("(5) A Casa de Spencer é descendente de um certo Henry Spencer (falecido provavelmente em "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://pt.wikipedia.org/wiki/1478",
      "target": "_blank",
      "title": "1478"
    }
  }, [_vm._v("1478")]), _vm._v("), também descendente das dinastias "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://pt.wikipedia.org/wiki/Casa_de_Stuart",
      "target": "_blank",
      "title": "Casa de Stuart"
    }
  }, [_vm._v("Stuart")]), _vm._v(" e "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://pt.wikipedia.org/wiki/Pr%C3%ADncipe_de_Orange",
      "target": "_blank",
      "title": "Príncipe de Orange"
    }
  }, [_vm._v("Orange")]), _vm._v(", e ancestral dos "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://pt.wikipedia.org/wiki/Conde_de_Sunderland",
      "target": "_blank",
      "title": "Conde de Sunderland"
    }
  }, [_vm._v("Condes de Sunderland")]), _vm._v(", os futuros "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://pt.wikipedia.org/wiki/Duque_de_Marlborough",
      "target": "_blank",
      "title": "Duque de Marlborough"
    }
  }, [_vm._v("Duques de Marlborough")]), _vm._v(", dos "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://pt.wikipedia.org/wiki/Conde_Spencer",
      "target": "_blank",
      "title": "Conde Spencer"
    }
  }, [_vm._v("Condes Spencer")]), _vm._v(" e de "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://pt.wikipedia.org/wiki/Diana,_Princesa_de_Gales",
      "target": "_blank",
      "title": "Diana, Princesa de Gales"
    }
  }, [_vm._v("Diana, Princesa de Gales")]), _vm._v(".  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-small",
      "text-align": "justify"
    }
  }, [_vm._v("(6) O Whig Party, era o partido que reunia as tendências liberais no Reino Unido, e contrapunha-se ao Tory Party, de linha conservadora. Whig é uma expressão de origem popular que se tornou termo corrente para designar o partido liberal no Reino Unido.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-small",
      "text-align": "justify"
    }
  }, [_vm._v("(7) O Royal Regiment of House Guards foi um regimento de cavalaria do Exército Britânico, parte da Household Cavalry. Criado em agosto de 1650 por Sir Arthur Haselrigge sob as ordens de Oliver Cromwell como um Regimento de Cavalaria. Como, exclusivamente, o casaco do regimento era de cor azul na época, foi apelidado de \"Oxford Blues\". O regimento tornou-se o Royal House Guards Blue e, eventualmente, em 1877, o Royal House Guards (The Blues). O regimento serviu nas Guerras Revolucionárias Francesas e na Guerra Peninsular. Dois esquadrões lutaram, com distinção, na Brigada Doméstica na Batalha de Waterloo. Em 1918, o regimento serviu como o 3º Batalhão, Regimento de Metralhadoras de Guardas. Durante a Segunda Guerra Mundial, o regimento fazia parte do Regimento Composto de Cavalaria Doméstica. Os Royal House Guards foram amalgamados com os Royal Dragoons (1st Dragoons) para formar os Blues and Royals (Royal House Guards e 1st Dragoons) em 1969. ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-269ca73a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c004.vue
// module id = 69
// module chunks = 0